import { createNamedStub } from "../../demo/stubHelpers";
import { asDemoLocale } from "../../demo/demoLocale";
import { filterCategories } from "../../demo/mockShopListings";

const categoryServices = {
  get: async (search: string, _academyId: string) =>
    asDemoLocale(filterCategories(search?.trim().toLowerCase() ?? "")),
  add: createNamedStub({}),
  update: createNamedStub({}),
  remove: createNamedStub({}),
};

export default categoryServices;
